export default __webpack_public_path__ + "KaTeX_SansSerif-Regular.5bf289005d5caccd361ab39e3a94f3b7.woff2";